import React, { useContext } from 'react';

import { LiveAnnouncerContext } from './context';
import LiveAnnouncerMessage from './LiveAnnouncerMessage/LiveAnnouncerMessage';

export default function LiveAnnouncerRenderer() {
  const { messagePolite, messageAssertive } = useContext(LiveAnnouncerContext);

  return (
    <>
      <LiveAnnouncerMessage message={messagePolite} ariaLive="polite" />
      <LiveAnnouncerMessage message={messageAssertive} ariaLive="assertive" />
    </>
  );
}
